import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SeasonExportService {
    private readonly http = inject(HttpClient);

    public exportApplications(seasonId: string): Observable<void> {
        const url = `${environment.apiUrl}/v1/seasons/${seasonId}/exports/applications`;
        return this.http.post<void>(url, null);
    }
}
